// Presentation of the Norwegian chart; never change balances or other countries' charts.
const trialBalanceDispositions = (groups: any[], country: string) => {
  if (country !== 'NO') return groups;
  const extra = [
    { key: 'finans', labelKey: 'rep.result.finance', pattern: /^8[01]\d{2}(?::|$)/ },
    { key: 'skatt', labelKey: 'rep.group.tax', pattern: /^83\d{2}(?::|$)/ },
    { key: 'disponeringer', labelKey: 'rep.group.dispositions', pattern: /^8[89]\d{2}(?::|$)/ },
  ].map(group => ({ key: group.key, labelKey: group.labelKey, match: (account: any) => group.pattern.test(String(account.nr).trim()) }));
  return [
    ...groups.map(group => ({ ...group, match: (account: any) => !extra.some(section => section.match(account)) && group.match(account) })),
    ...extra,
  ];
};
window.PlummeTrialBalanceDispositions = trialBalanceDispositions;
